
import {Component, Vue, Watch} from 'vue-property-decorator';
import SetTableColumns from "@/components/SetTableColumns.vue";
import {IPage} from "@/js/page";
import {authorizeCertApi, dictApi, measuringStandardApi} from "@/api/organization";
import baseUrl from "@/constants";
import {materialApi} from '@/api/material';
import {materialTypeList} from "@/js/checkType";

const {regionData, CodeToText} = require("@/js/region/region");
@Component({
  name: 'MaterialList',
  components: {SetTableColumns}
})
export default class MaterialList extends Vue {
  mode = "This_Unit"; //This_Unit 本单位 Examine 审核,Share 共享
  modeValue = "ALL";//ALL 所有
  modeType = "Material";//Material：标准物质 ShareMaterial：已共享标准物质
  CodeToText = CodeToText;
  regionData = regionData;
  mainDevOrgId = '';
  private exportExcel: any;
  showAccuracy = {
    visible: false,
    data: []
  }
  private closePage: any;
  screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
  showForm = false;//查询条件隐藏展示
  load = false;//加载
  dataList = []; //数据列表
  mechanismTypeList = [];//单位类型字典
  tabCol = [];
  allSelected = [];//列表选中数据
  propParams = this.getPropParams();
  typeList = materialTypeList
  total = 0;
  sysMaterialUpdate = true;
  listParam: IPage = {
    size: 50,
    current: 1,
  };

  getPropParams() {
    return {
      name: '',
      useStatus: '',
      form: '',
      number: '',
      certNumber: '',
      issuingAuthority: '',
      materialNumber: '',
      devOrgName: '',
      orgName: '',
      level: '',
      type: '',
      status: '',
      shareStatus: '',
      issuedDate: '',
      issuedDateEnd: '',
      sortBy: 'status'
    }
  }

  created() {
    this.haveRight();
    this.listOrganizationTypeName();
    this.init();
  }

  activated() {
    if (this.$route.meta && !this.$route.meta.isBack) {
      this.showForm = false;
      this.reset();
    } else {
      this.init();
    }
    this.tableClearSelect();
  }

  reset() {
    this.propParams = this.getPropParams();
    this.refresh();
  }

  tableClearSelect() {
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    if ($table) {
      $table.clearSelection();
    }
  }

  init() {
    const route = this.$route;
    const q = JSON.parse(JSON.stringify(route.query));
    if (q.size) {
      this.listParam.size = Number(q.size);
      this.listParam.current = Number(q.current);
    }
    this.mode = this.$route.params.mode
    this.modeValue = this.$route.params.modeValue;
    if (this.$route.params.modeType) {
      this.modeType = this.$route.params.modeType;
    }
    this.mainDevOrgId = this.$route.params.mainDevOrgId;
    this.loadData(null);
  }

  getTitle() {
    if (this.mode === 'This_Unit' && this.modeValue === 'ALL') {
      return "本单位全部标准物质";
    } else if (this.mode === 'This_Unit' && this.modeValue === 'CUR') {
      return "本单位当前标准物质";
    } else if (this.mode === 'This_Unit' && this.modeValue === 'HIS') {
      return "本单位历史标准物质";
    } else if (this.mode === 'This_Area' && this.modeValue === 'ALL') {
      return "本区域全部标准物质";
    } else if (this.mode === 'This_Area' && this.modeValue === 'CUR') {
      return "本区域当前标准物质";
    } else if (this.mode === 'This_Area' && this.modeValue === 'HIS') {
      return "本区域历史标准物质";
    } else if (this.mode === 'Share') {
      return "本区域当前标准物质";
    } else if (this.mode === 'Examine') {
      return "全部待审核标准物质";
    } else if (this.mainDevOrgId) {
      return "企业标准物质";
    } else {
      return "";
    }
  }

  hasBtn(mode: string) {
    if (mode === 'Add') {
      return this.mode === 'This_Unit' && this.modeType === 'Material' && this.modeValue === 'ALL';
    } else if (mode === 'Excel') {
      return true;
    } else if (mode === 'Look') {
      return true;
    } else if (['Edit', 'Edit_Use_Status'].includes(mode)) {
      return (this.mode === 'This_Unit' && this.modeType === 'Material' && this.modeValue === 'ALL')
    } else if (mode === 'Submit') {
      return this.mode === 'This_Unit' && this.modeType === 'Material' && this.modeValue === 'ALL';
    } else if (mode === 'Del') {
      return (this.mode === 'This_Unit' && this.modeType === 'Material' && this.modeValue === 'ALL');
    } else if (mode === 'Examine') {
      return this.mode === 'Examine' && this.modeType === 'Material' && this.sysMaterialUpdate && this.modeValue === 'ALL';
    } else if (mode === 'Share') {
      return this.mode === 'Share';
    } else if (mode === 'Release') {
      return this.mode === 'Share' && this.modeType === 'Material';
    } else if (mode === 'Recall') {
      return this.mode === 'Share' && this.modeType === 'ShareMaterial';
    } else if (mode === 'Revoke') {
      return (this.mode === 'This_Unit' && this.modeType === 'Material' && this.modeValue === 'ALL')
      || (this.mode === 'Examine' && this.modeType === 'Material' && this.modeValue === 'DONE');
    } else if (mode === 'close') {
      return this.mainDevOrgId;
    }
    return false;
  }

  loadData(callback: any) {
    this.tableClearSelect();
    const route = this.$route;
    let q = JSON.parse(JSON.stringify(route.query));
    q = Object.assign(q, this.listParam);
    for (const key in q) {
      q[key] = String(q[key]);
    }
    const args = {
      mode: this.mode,
      mainDevOrgId: this.mainDevOrgId,
      modeValue: this.modeValue,
      modeType: this.modeType,
      ...this.listParam,
      ...this.propParams,
    } as any;
    this.load = true;
    materialApi.page(args).then((r: any) => {
      if (r.data.result === 0) {
        const rData = r.data.data.records;
        this.total = r.data.data.total;
        this.dataList = rData;
        if (callback) {
          callback();
        }
        this.$nextTick(() => {
          let $table = this.$refs.table as HTMLFormElement;
          if ($table) {
            $table.doLayout();
          }
          this.load = false;
        })
      }
    });
  }

  indexMethod(index: any) {
    return (this.listParam.current - 1) * this.listParam.size + index + 1;
  }

  changeTabCol(e: any) {
    this.tabCol = e;
    this.$nextTick(() => {
      let $table = this.$refs.table as HTMLFormElement;
      if ($table) {
        $table.doLayout();
      }
    })
  }

  haveRight() {
    // const right = this.$store.state.userRights;
    // right.forEach((e: any) => {
    //     if (e.name == "计量标准审核") {
    //         this.sysMaterialUpdate = true;
    //     }
    // })
  }

  toDetail(type: string) {
    const dataArr = this.allSelected as any;
    let id = 0;
    if (['Add', 'ORIGINAL_ADD'].indexOf(type) === -1) {
      if (dataArr.length == 0) {
        this.$message.error("请先勾选");
        return;
      }
      if (type === 'Return') {
        this.batchReturn(dataArr);
        return;
      }
      if (type === 'Revoke') {
        this.batchRevoke(dataArr);
        return;
      }
      if (type === 'Release' || type == "Recall") {
        this.batchReleaseOrRecall(dataArr, type);
        return;
      }
      if (type == 'Del') {
        this.batchDelete(dataArr);
        return;
      }
      if(['batch_edit_use_status_在产', 'batch_edit_use_status_注销'].includes(type)){
        this.batchEditUseStatus(dataArr, type);
        return;
      }

      if (dataArr.length > 1 && (type == 'Look' || type == 'Edit' || type == 'Examine')) {
        this.$message.error("只能勾选一条");
        return;
      }
      if (type == 'Submit') {
        this.batchSubmit(dataArr);
        return;
      }
      if (type == 'Edit') {
        this.toEdit(dataArr[0], type);
        return;
      }
      id = dataArr[0].id;
    }
    this.goDetail(type, id);
  }

  batchDelete(dataArr: any) {
    this.$confirm('您勾选了:  ' + dataArr.length + '条标准物质，是否删除', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      materialApi.delete({ids: dataArr.flatMap((e: any) => e.id).join(",")}).then((r: any) => {
        if (r.data.result === 0) {
          this.$message.success("删除成功");
          this.loadData(null);
        }
      });
    });
  }

  cloneData(data: any) {
    return JSON.parse(JSON.stringify(data));
  }

  goDetail(type: string, id: number) {
    const firstRouterText = this.$route.path.split("/")[1];
    this.$router.push("/" + firstRouterText + "/detail/" + id + "/" + this.mode + "/" + type);
  }

  openDialog(id: number) {
    materialApi.get(id).then((r: any) => {
      if(r.data.result === 0){
        const {materialData} = r.data.data;
        if(materialData){
          materialData.forEach((d: any) => {
            d.data = JSON.parse(d.data);
          });
          this.showAccuracy.data = materialData;
        }else{
          this.showAccuracy.data = [];
        }
        this.showAccuracy.visible = true;
      }
    });
  }

  toEdit(data: any, type: string) {
    if (data.status.value === 2) {
      this.$confirm('您勾选的是审核“已通过”的标准物质，编辑并保存后需要重新提交审核，是否继续编辑？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.goDetail(type, data.id);
      });
    } else {
      this.goDetail(type, data.id);
    }
  }

  batchReleaseOrRecall(dataArr: any, type: string) {
    this.$confirm('您勾选了:  ' + dataArr.length + '条标准物质，是否' + (type == 'Release' ? '发布' : '撤回') + '？', '提示', {
      confirmButtonText: '是',
      cancelButtonText: '否',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }).then(() => {
      materialApi.batchReleaseOrRecall({
        ids: dataArr.flatMap((e: any) => e.id).join(","),
        shareStatus: type == 'Release' ? 1 : 2
      }).then((r: any) => {
        if (r.data.result === 0) {
          this.$message.success((type == 'Release' ? '发布' : '撤回') + "成功");
          this.loadData(null);
        }
      });
    });
  }

  batchRevoke(dataArr: any) {
    this.$confirm('确定要撤销标准物质名称为:  ' + dataArr.flatMap((e: any) => e.val2).join(",") + '？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }).then(() => {
      materialApi.batchRevoke({ids: dataArr.flatMap((e: any) => e.id).join(",")}).then((r: any) => {
        if (r.data.result === 0) {
          this.$message.success("撤销成功");
          this.loadData(null);
        }
      });
    });
  }

  batchReturn(dataArr: any) {
    this.$confirm('您勾选了:  ' + dataArr.length + '条标准物质，是否退回？', '提示', {
      confirmButtonText: '是',
      cancelButtonText: '否',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }).then(() => {
      materialApi.batchReturn({ids: dataArr.flatMap((e: any) => e.id).join(",")}).then((r: any) => {
        if (r.data.result === 0) {
          this.$message.success("退回成功");
          this.loadData(null);
        }
      });
    });
  }

  batchSubmit(dataArr: any) {
    this.$confirm('您勾选了' + dataArr.length + '条标准物质，是否提交审核？', '提示', {
      confirmButtonText: '是',
      cancelButtonText: '否',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }).then(() => {
      materialApi.batchSubmit({ids: dataArr.flatMap((e: any) => e.id).join(",")}).then((r: any) => {
        if (r.data.result === 0) {
          this.$message.success("提交成功");
          this.loadData(null);
        }
      });
    });
  }

  batchEditUseStatus(dataArr: any, type: string) {
   const useStatus =  type === 'batch_edit_use_status_在产' ? '在产' : '注销';
    this.$confirm('您勾选了' + dataArr.length + '条标准物质，确定将使用状态改为' + useStatus +'？', '提示', {
      confirmButtonText: '是',
      cancelButtonText: '否',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }).then(() => {
      materialApi.batchEditUseStatus({ids: dataArr.flatMap((e: any) => e.id).join(","), useStatus: useStatus}).then((r: any) => {
        if (r.data.result === 0) {
          this.$message.success("提交成功");
          this.loadData(null);
        }
      });
    });
  }

  refresh() {
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    $table.clearSelection();
    this.listParam.current = 1;
    // if(this.modeType === 'ShareMaterial'){
    //   this.propParams.shareStatus = '1';
    // }
    this.loadData(null);
  }

  listOrganizationTypeName() {
    dictApi.listDictItem({typeCode: "dwlb"}).then((r) => {
      if (r.data.result === 0) {
        this.mechanismTypeList = r.data.data;
      }
    });
  }

  pageSizeChange(val: number) {
    this.listParam.size = val;
    this.refresh();
  }

  pageCurrentChange(val: number) {
    this.listParam.current = val;
    this.loadData(null);
  }

  memberSelect(selection: any, row: any) {
    this.allSelected = selection;
  }

  down(row: any) {
    try {
      const obj = JSON.parse(row);
      if (typeof obj == 'object' && obj) {
        window.open(baseUrl + "/file/download?file=" + obj[0].url + "&name=" + obj[0].name, '_blank');
        return true;
      } else {
        return false;
      }
    } catch (e) {
      window.open(baseUrl + "/file/download?file=" + row + "&name=标准物质证书影印件", '_blank');
      return false;
    }
  }

  onExportExcel() {
    const loading = this.$loading({
      text: '正在导出Excel',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    const listParam = JSON.parse(JSON.stringify(this.listParam));
    this.listParam.size = this.total;    //将表格长度变成数据总长度
    this.listParam.current = 1;          //显示第一页
    this.loadData(() => {
      this.exportExcel(() => {
        this.listParam = listParam;    //表格长度还原
        this.loadData(null);
        loading.close();
      }, "标准物质列表.xlsx");
    });
  }
}
